<template>
	<div class="outer">
		<div class="search flex">
			<span class="tit">用户聊天</span>
		</div>
		<div class="user_box">
			<div class="user_title">会话列表</div>
			<div class="user_list">
				<ul>
					<li :key="index" v-for="(user,index) in userList" @click="changeUser($event,user)"
							:class="[user.online?'':'offline']">
						<img src="http://test.immvira.cn/upload/20200716/159486646862668.png">
						<span class="user_name">临时用户{{user.uid}}</span>
						<div v-if="user.num>0" class="user_tips">{{user.num}}</div>
					</li>
				</ul>
			</div>
		</div>
		
		
		<div class="chat_box" id="chat_block">
			<div class="chat_box_title">
				<!--<img src="http://test.immvira.cn/upload/20200715/159480613509821.jpg"/>-->
				<span v-if="curUser">正在与{{curUser}}对话</span>
			</div>
			
			<div class="chat_box_content">
				<div :key="index" v-for="(msg,index) in curChatRecord" :class="[msg.type==1?'client':'server']">
					<span :class="['msg',msg.type==1?'client':'server']">{{msg.content}}</span>
				</div>
			</div>
			
			<div class="chat_box_input">
				<textarea id="message_text" placeholder="请输入" @keypress="toSend($event)"></textarea>
			</div>
			<div class="flex btnGroup">
				<el-button size="small" id="send-btn" @click="sendMsg()">发送</el-button>
				<el-button size="small" id="record-btn" @click="recoverChat()">聊天记录</el-button>
			</div>
		
		</div>
		<audio id="audio_tip" src="http://ppt.yshlab.com/audio/123.wav"></audio>
	</div>

</template>

<script>
  import base from '@/api/common';

  export default {
    name: "chatServer",
    data() {
      return {
        webSocket: null,
        uid: '',
        token: '',
        default_open: true,
        wsUrl: base.api.chat,

        curUser: "",
        curChatRecord: [],
        userList: [],
        chatMap: new Map(),
      }
    },
    mounted() {
      window.console.font = function (msg, size, color, bgColor) {
        if (isNaN(Number(size))) {
          size = 12
        }
        if (size > 50 || size < 12) {
          size = 12;
        }
        if (!color) {
          color = "#fff"
        }
        if (!bgColor) {
          bgColor = "green"
        }
      };
      // 获取用户
      this.$ajax.post(base.api.current).then(res => {
        if (res.data.status === 'success') {
          this.uid = res.data.data.uid;
          this.getTokenAndInitWebsocket();
        }
      })
    },
    methods: {
      getTokenAndInitWebsocket() {
        if (!this.uid) {
          return;
        }
        this.$ajax.get(base.manager_api.chat.token.replace("{uid}", this.uid)).then(res => {
          if (res.data.status === 'success') {
            this.token = res.data.data;
            if (this.default_open) {
              this.initWebSocket();
            }
          } else {
            this.$message.error(res.data.message);
          }
        })
      },
      changeUser(event, user) {
        $(".user_list li").removeClass("active");
        event.currentTarget.classList.add("active");
        // 未读消息置空 切换聊天对象
        user.num = 0;
        this.curUser = user.uid;
        this.curChatRecord = this.chatMap.get(user.uid);
      },
      hasUser(uid) {
        let has = false;
        $(this.userList).each((i, u) => {
          if (uid === u.uid) {
            has = true;
            return false;
          }
        });
        return has;
      },
      getUser(uid) {
        let user = null;
        $(this.userList).each((i, u) => {
          if (uid === u.uid) {
            user = u;
            return false;
          }
        });
        return user;
      },
      toSend(e) {
        if (e.keyCode === 13) {
          e.preventDefault();
          this.sendMsg();
        }
      },
      sendMsg() {
        // TODO
        let message = $("#message_text").val();
        if ($.trim(message).length === 0) {
          return;
        }
        if (!this.webSocket) {
          console.error("websocket 未就绪");
          return;
        }

        if (!this.curUser) {
          alert("未选择发送对象");
          return;
        }
        let sendUser = this.getUser(this.curUser);
        if (sendUser == null || !sendUser.online) {
          alert("对方不在线");
          return;
        }
        try {
          let data = {
            to: this.curUser, // TODO
            msg: message,
            type: 'server'
          };
          this.webSocket.send(JSON.stringify(data));

          this.chatMap.get(this.curUser).push({
            date: new Date().getTime(),
            content: message,
            type: 1
          });
        } catch (e) {
          console.error(e);
          alert("发送失败");
          return;
        }
        this.$nextTick(this.scrollToLast());
        $("#message_text").val("");
      },
      initWebSocket(then) {
        let url = this.wsUrl + this.uid;
        if (this.token) {
          url = this.wsUrl + this.uid + "?token=" + this.token;
        }
        this.webSocket = new WebSocket(url);
        this.webSocket.onopen = () => {
          console.font("webSocket is on opened....", 14, "#FFF", "green");
          if (then) {
            then();
          }
        };
        this.webSocket.onclose = () => {
          console.font("webSocket is on closed....", 14, "#000", "#E9DA75");
        };
        this.webSocket.onerror = (e) => {
          console.font("webSocket error....", 14, "#FFF", "#F00");
          console.error(e);
        };
        this.webSocket.onmessage = (event) => {
          // console.info(event);
          let message = JSON.parse(event.data);
          let type = message.type;
          if (type === 'plainText') {
            this.handleMessage(message);
          } else if (type === 'leave') {
            this.handleUserLeave(message);
          } else if (type === 'open') {
            let openUser = this.getUser(message.userId);
            if (openUser != null) {
              openUser.online = true;
            }
          }
        }
      },
      handleMessage(message) {
        $("#audio_tip")[0].play();
        if (!this.hasUser(message.userId)) { //不存在
          // 添加会话
          this.userList.push({
            uid: message.userId,
            num: 1,
            online: true
          });
          // 添加记录
          this.chatMap.set(message.userId, [{
            date: new Date().getTime(),
            content: message.msg,
            type: 0 //0-对方 1-自己
          }]);
          return;
        }
        this.chatMap.get(message.userId).push({
          date: new Date().getTime(),
          content: message.msg,
          type: 0
        });

        if (this.curUser != message.userId) { //存在且非当前会话 未读消息+1
          let user = this.getUser(message.userId);
          if (user != null) {
            user.num = user.num + 1;
          }
        } else { // 当前会话
          this.curChatRecord = this.chatMap.get(message.userId);
          this.$nextTick(this.scrollToLast());
        }
      },
      handleUserLeave(data) {
        let leaveUserId = data.userId;
        let leaveUser = this.getUser(leaveUserId);
        if (leaveUser != null) {
          leaveUser.online = false;
        }
      },
      scrollToLast() {
        let maxHeight = $(".chat_box_content")[0].scrollHeight;
        $(".chat_box_content").animate({scrollTop: maxHeight}, 800);
        $("#message_text").focus();
      },
      recoverChat() {
        let chatUid = this.curUser;
        if (!chatUid) {
          alert("先选择对象");
        }
        this.$ajax.post(base.manager_api.chat.recover.replace("{sessionId}", chatUid)).then(res => {
          if (res.data.status === 'success') {
            let records = res.data.list;
            if (records.length > 0) {
              let historyRecord = [];
              $(records).each((i, o) => {
                let recode = JSON.parse(o);
                historyRecord.push({
                  type: recode.type == "client" ? 0 : 1,
                  time: recode.time,
                  content: recode.content
                })
              });
              this.curChatRecord = historyRecord;
              this.chatMap.set(chatUid, historyRecord);
            }
          } else {
            this.$message.error(res.data.message);
          }
        }).catch((err) => {
          console.error(err)
          this.$message.error("获取数据失败");
        })
      }
    }
  }
</script>

<style scoped lang="scss">
@import '../../../assets/css/chatServer.scss';
</style>